<template>
  <div class="footer-wrapper">
    <footer v-if="!isMobile" class="footer">
      <ul class="footer__left-side">
        <li>
          <styled-language-select
            v-on-clickaway="hideLanguage"
            :class="{ 'footer__custom-select--opened': langDropIsOpen }"
            :lang-drop-is-open="langDropIsOpen"
            class="footer__custom-select"
            @click="clickLanguage">
            <selected-item ref="selectLanguage" :lang-drop-is-open="langDropIsOpen">
              <span ref="selectLanguageText">{{ renderCurrentLanguage() }}</span>

              <transition name="langDrop">
                <language-enumeration v-if="langDropIsOpen" :lang-drop-is-open="langDropIsOpen">
                  <language-select-item
                    v-for="(item, index) in langsList"
                    :key="index"
                    @click="selectLanguage($event, item.l)"
                    >{{ $t(item.t) }}</language-select-item
                  >
                </language-enumeration>
              </transition>

              <select-arrow-svg />
            </selected-item>

            <!-- <div
              class="footer__custom-select__selected"
              :class="{'footer__custom-select__selected--open': langDropIsOpen}"
              ref="selectLanguage"
            >
              <span ref="selectLanguageText">{{ renderCurrentLanguage() }}</span>
              <transition name="langDrop">
                <ul :class="{'open': langDropIsOpen}" v-if="langDropIsOpen">
                  <li
                    v-for="(item, index) in langsList"
                    :key="index"
                    @click="selectLanguage($event, item.l)"
                  >{{ $t(item.t) }}</li>
                </ul>
              </transition>

              <select-arrow-svg/>
            </div>-->
          </styled-language-select>
        </li>
      </ul>

      <ul class="footer__right-side">
        <li v-if="isPCLogoShown" class="powered">
          <a href="https://corefy.com/" target="_blank">
            <div class="powered__text">{{ $t('powered_by') }}</div>
            <powered-main-svg />
          </a>
        </li>
      </ul>
    </footer>

    <footer-mob v-else />
  </div>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway';
import FooterMob from '@/components/Footer/FooterMob';

import SelectArrowSvg from '@/components/svg/SelectArrow';
import PoweredMainSvg from '@/components/svg/PoweredMain';

import styled from 'vue-styled-components';
import { mapState } from 'vuex';
import parseAvailableLocales from '@/helpers/parseAvailableLocales';

const selectProps = {
  langDropIsOpen: Boolean,
};
const enumerationProps = {
  langDropIsOpen: Boolean,
};

const styledLanguageSelect = styled('div', enumerationProps)`
  border-radius: var(--border_radius);
  border: var(--border);
  border-color: var(--border_color);

  color: ${props => (props.langDropIsOpen ? `var(--on_secondary)` : `var(--on_surface)`)};
  background-color: ${props => (props.langDropIsOpen ? `var(--secondary)` : `var(--surface)`)};

  &:hover {
    background-color: var(--secondary) !important;
    color: var(--on_secondary) !important;
  }

  width: 110px;
  padding: 5px 10px;
  transition: background 0.3s, color 0.3s;
`;

const selectedItem = styled('div', selectProps)`
  display: flex;
  justify-content: space-between;
  align-items: center;

  svg {
    transform: ${props => (props.langDropIsOpen ? 'rotate(181deg)' : 'none')};
  }
`;

const languageSelectEnumeration = styled('ul', enumerationProps)`
  box-shadow: var(--box_shadow)
  border-radius: var(--border_radius);
  background-color: var(--secondary_background_color) !important;
  border: var(--border);
  border-color: var(--border_color);


  li {
    &:nth-child(1) {
      border-top-left-radius: var(--border_radius);
      border-top-right-radius: var(--border_radius);
    }
    &:last-of-type {
      border-bottom-left-radius: var(--border_radius);
      border-bottom-right-radius: var(--border_radius);
    }
  }
`;

const languageSelectItem = styled('li')`
  background-color: var(--surface) !important;
  color: var(--on_surface);

  &:hover {
    color: var(--on_secondary);
    background-color: var(--secondary) !important;
  }
`;

const DEFAULT_AVAILABLE_LOCALES = [
  { l: 'en', t: 'in_english' },
  { l: 'ru', t: 'in_russian' },
  { l: 'uk', t: 'in_ukrainian' },
  { l: 'sw', t: 'in_swahili' },
];

export default {
  name: 'FooterComponent',

  directives: { onClickaway },

  components: {
    SelectArrowSvg,
    PoweredMainSvg,
    FooterMob,
    styledLanguageSelect,
    selectedItem,
    languageEnumeration: languageSelectEnumeration,
    languageSelectItem,
  },

  data() {
    return {
      langDropIsOpen: false,
    };
  },

  computed: {
    ...mapState('UI', ['customThemeOptions', 'availableLocales', 'queryLocale']),
    ...mapState(['checkoutOptions']),

    isMobile() {
      return this.screenSize.width < 769;
    },
    isPCLogoShown() {
      return !!(this.customThemeOptions || {}).PСLogo;
    },

    defaultLocales() {
      return this.$i18n.locale === 'en' ? ['en'] : [this.$i18n.locale, 'en'];
    },

    langsList() {
      let data = this.defaultLocales;

      const optionLocales = parseAvailableLocales(
        this.availableLocales,
        this.checkoutOptions?.available_locales,
        DEFAULT_AVAILABLE_LOCALES.map(el => el.l)
      );

      if (optionLocales.length) {
        data = optionLocales;

        if (this.queryLocale || this.checkoutOptions?.locale) {
          const selectedLocale = this.queryLocale || this.checkoutOptions?.locale;

          if (
            DEFAULT_AVAILABLE_LOCALES.map(el => el.l === selectedLocale) &&
            data.some(locale => locale === selectedLocale)
          ) {
            data.push(selectedLocale);
          }
        }
      }

      return DEFAULT_AVAILABLE_LOCALES.filter(el => data.includes(el.l));
    },
  },

  methods: {
    clickLanguage() {
      this.langDropIsOpen = !this.langDropIsOpen;
      this.checkLanguageSelect();
    },

    hideLanguage() {
      this.langDropIsOpen = false;
      this.checkLanguageSelect();
    },

    checkLanguageSelect() {
      // this.langDropIsOpen
      //   ? (this.$refs.selectLanguage.style.backgroundColor = "#0055cc")
      //   : (this.$refs.selectLanguage.style.backgroundColor = "");
    },

    renderCurrentLanguage() {
      const locale = this.$i18n.locale;

      if (locale === 'ru') {
        return this.$t('in_russian');
      }

      if (locale === 'uk') {
        return this.$t('in_ukrainian');
      }

      if (locale === 'sw') {
        return this.$t('in_swahili');
      }

      return this.$t('in_english');
    },

    selectLanguage(e, locale) {
      e.stopPropagation();
      this.langDropIsOpen = false;
      const liText = e.target.innerText;
      this.$refs.selectLanguageText.innerText = liText;
      this.checkLanguageSelect();
      this.$bus.$emit('changeLocale', locale);
    },
  },
};
</script>

<style lang="scss" scoped>
.footer__left-side ul {
  border-radius: var(--border_radius);
}
</style>
